.mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:none}.mat-expansion-panel{margin-bottom:15px;background-color:#fff;border-top:1px solid lightgrey;border-bottom:1px solid lightgrey}
/*# sourceMappingURL=/ba/public/expansion-panel.component.css.map */
